var _ellipse, _path, _path2, _path3, _path4, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcons8Javascript(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: "200px",
    height: "200px",
    baseProfile: "basic",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 32,
    cy: 61,
    opacity: 0.3,
    rx: 20,
    ry: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffce29",
    d: "M54,20v24c0,2.25-0.74,4.32-2,5.99V50c-1.69,2.24-4.29,3.75-7.25,3.97C44.51,53.99,44.25,54,44,54 H20c-5.52,0-10-4.48-10-10V20c0-0.25,0.01-0.51,0.03-0.75c0.22-2.96,1.73-5.56,3.97-7.25h0.01c1.67-1.26,3.74-2,5.99-2h24 C49.52,10,54,14.48,54,20z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14.01,12H14c-2.24,1.69-3.75,4.29-3.97,7.25C10.01,19.49,10,19.75,10,20v12 c2.761,0,5-2.239,5-5v-7c0-0.108,0.003-0.221,0.017-0.38c0.102-1.375,0.778-2.65,1.862-3.525c0.048-0.033,0.095-0.068,0.142-0.103 C17.881,15.343,18.911,15,20,15h6c2.761,0,5-2.239,5-5H20C17.75,10,15.68,10.74,14.01,12z",
    opacity: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54,44V28c-2.761,0-5,2.238-5,5v11c0,2.757-2.243,5-5,5H33c-2.761,0-5,2.238-5,5h16 C49.523,54,54,49.523,54,44z",
    opacity: 0.15
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M13.5,23.5V20c0-0.153,0.005-0.312,0.018-0.459c0.135-1.809,1.003-3.46,2.396-4.594l0.204-0.152"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#9c34c2",
    d: "M28.441,47.566c-0.453,0.013-0.807-0.106-1.061-0.36c-0.253-0.253-0.38-0.58-0.38-0.981 c0-0.306,0.09-0.574,0.271-0.802c0.179-0.227,0.443-0.352,0.791-0.38l0.58-0.041c1.069-0.065,1.602-0.628,1.602-1.682v-8.632 c0-0.507,0.134-0.898,0.401-1.172c0.267-0.274,0.647-0.411,1.143-0.411c1.04,0,1.561,0.528,1.561,1.583v8.593 c0,2.657-1.402,4.072-4.207,4.246L28.441,47.566z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c34c2",
    d: "M41.219,47.626c-0.854,0-1.71-0.093-2.564-0.28c-0.854-0.186-1.596-0.46-2.223-0.821 c-0.373-0.2-0.608-0.469-0.701-0.81c-0.093-0.341-0.073-0.672,0.06-0.993c0.134-0.319,0.347-0.546,0.641-0.68 c0.293-0.134,0.647-0.101,1.061,0.099c0.535,0.308,1.13,0.535,1.783,0.681c0.654,0.147,1.302,0.22,1.943,0.22 c0.962,0,1.653-0.15,2.073-0.45c0.421-0.302,0.631-0.678,0.631-1.133c0-0.386-0.147-0.694-0.44-0.921 c-0.295-0.227-0.808-0.421-1.544-0.58l-2.262-0.481c-2.523-0.535-3.786-1.843-3.786-3.926c0-0.893,0.241-1.679,0.722-2.354 c0.481-0.673,1.151-1.198,2.013-1.571c0.861-0.373,1.858-0.561,2.994-0.561c0.747,0,1.482,0.09,2.202,0.271 c0.722,0.179,1.356,0.443,1.904,0.791c0.333,0.2,0.541,0.461,0.621,0.781c0.08,0.321,0.057,0.628-0.07,0.923 c-0.127,0.293-0.341,0.5-0.641,0.619c-0.302,0.121-0.672,0.075-1.112-0.14c-0.442-0.227-0.91-0.393-1.403-0.5 c-0.494-0.106-1.001-0.16-1.522-0.16c-0.841,0-1.491,0.163-1.953,0.491c-0.46,0.328-0.691,0.751-0.691,1.271 c0,0.388,0.14,0.701,0.422,0.942c0.28,0.24,0.768,0.434,1.462,0.58l2.262,0.481c2.59,0.561,3.886,1.83,3.886,3.806 c0,0.88-0.238,1.653-0.711,2.313c-0.474,0.662-1.143,1.175-2.003,1.542C43.413,47.442,42.395,47.626,41.219,47.626z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Javascript);
export default __webpack_public_path__ + "static/media/icons8-javascript.37b0d4229d2d5e4f4ccbe90b1eda868c.svg";
export { ForwardRef as ReactComponent };